import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import FormControl from "@material-ui/core/FormControl";
import { Button, FormGroup } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import { Search } from "@material-ui/icons";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

class AdvancedSearchMenu extends React.Component {
  state = {
    anchorEl: null,
    query: "",
    loading: false,
    queryType: "FREETEXT"
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { basicSearchStore, onSave } = this.props;
    const { anchorEl } = this.state;
    return (
      <div>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ padding: "6px" }}
        >
          <Search />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <FormGroup style={{ padding: "12px", marginBottom: "0.5rem" }}>
            <FormControl style={{ margin: "8px" }}>
              <TextField
                id="query"
                label="Advanced Search"
                placeholder={"ohtani home runs over 400ft"}
                multiline
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  style: {
                    resize: "vertical",
                    overflow: "auto",
                    minWidth: "400px"
                  }
                }}
                value={this.state.query}
                onKeyDown={e => e.stopPropagation()}
                onChange={e => {
                  this.setState({ query: e.target.value });
                }}
                minRows={4}
              />
            </FormControl>
          </FormGroup>

          <Divider />

          <div
            style={{
              padding: "8px",
              paddingTop: "16px",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch checked={this.state.queryType === "STRUCTURED"} />
                }
                label={this.state.queryType}
                onChange={() => {
                  this.setState({
                    queryType:
                      this.state.queryType === "FREETEXT"
                        ? "STRUCTURED"
                        : "FREETEXT"
                  });
                }}
              />
            </FormGroup>
            <Button
              size={"small"}
              color={"primary"}
              disabled={this.state.loading}
              onClick={e => {
                if (this.state.query !== "") {
                  this.setState({ loading: true });
                  basicSearchStore
                    .setClauses(this.state.query, this.state.queryType)
                    .then(() => {
                      onSave && onSave();
                      this.setState({ loading: false });
                      this.handleClose();
                    });
                } else {
                  onSave && onSave();
                  this.handleClose();
                }
              }}
            >
              {this.state.loading ? (
                <CircularProgress size={"small"} />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Menu>
      </div>
    );
  }
}

export default inject(
  "basicSearchStore",
  "matchupsDialogStore"
)(observer(AdvancedSearchMenu));



// WEBPACK FOOTER //
// ./src/components/AdvancedSearchMenu.js